import React from 'react';
import * as Tools from "../../helpers/Tools";
import { withRouter } from "react-router-dom";
import { Card, Divider, Icon, Thumbnail, Typography } from "../ecosystem";
import FavoriteDrButton from './FavoriteDrButton';
import DrNameSpecialty from './DrNameSpecialty';

const RecentDrCard = ({
    provider,
    npi,
    isMobile,
}) => {
    const provName = provider && provider?.ProviderName ? Tools.trimComma(provider.ProviderName) : '';
    const provSpecialty = provider && provider?.ProviderSpecialities
        ? provider.ProviderSpecialities.map((specialty) => specialty).join(",")
        : '';
    const provUrl = npi ? "/providers/" + npi : '';

    return (
        <Card className="recent-doctors">
            {!isMobile &&
                <div className="recent-doctors__fav-icon-button">
                    <FavoriteDrButton
                        NPI={npi}
                        isRecentDocFavorited={!provider.IsFavorited}
                    />
                </div>
            }
            <div className="row favorite-doctors-card__content">
                <div className="col-12 recent-doctors__profile">
                    <div className="row">
                        <div className="col recent-doctors__thumbnail">
                            <Thumbnail
                                source={provider.ProviderPhotoUrl ? provider.ProviderPhotoUrl : ''}
                                icon="doctor"
                                size={isMobile ? "sm" : "xs"}
                                altText={provName}
                            />
                        </div>
                        <div className="col recent-doctors__info">
                            <DrNameSpecialty
                                name={provName}
                                specialty={provSpecialty}
                                provUrl={provUrl}
                                size="sm"
                            />
                            {provider.LastAppointmentDate &&
                                <div className="recent-doctors__last-appt">
                                    <div className="recent-doctors__appt-icon"><Icon name="calendar" color="$color-secondary-a2" /></div>
                                    <Typography type="body-02">
                                        Last Visited: {Tools.getDateStrByFormat(provider.LastAppointmentDate, 'ddd MM/DD')}
                                    </Typography>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {isMobile &&
                    <div className="col-12 recent-doctors__cta">
                        <Divider
                            mLeft="none"
                            mRight="none"
                            mTop="small"
                            mBottom="small"
                        />
                        <FavoriteDrButton NPI={npi} showLabel />
                    </div>
                }
            </div>
        </Card >
    )
}

export default withRouter(RecentDrCard);